export default __webpack_public_path__ + "static/media/promotion-banner-one-tab.03dac7a9.png";